import { observer } from "mobx-react-lite";
import styles from './Modal.module.css';

function Modal({ header, children, fullWidth, midWidth, className, onClose }: IModalProps) {
    return (
        <div className={styles.background} onClick={e => {
            e.stopPropagation();
            if (e.target === e.currentTarget) onClose();
        }}>
            <div className={[styles.container, fullWidth && styles.fullWidth, midWidth && styles.midWidth, className].join(" ")} onClick={e => e.stopPropagation()}>
                {header && <div className={styles.header}>{header}</div>}
                <div className={styles.body}>
                    {children}
                </div>
            </div>
        </div>
    );
}

export default observer(Modal);

interface IModalProps {
    header?: string;
    children: React.ReactNode;
    fullWidth?: boolean;
    midWidth?: boolean;
    className?: string;
    onClose: () => void;
}